<template>
  <div class="section-invoice" id="invoce">
		<p class="title-invoice">FACTURA Y ADMINISTRA</p>
		<p class="subtitle-invoice">VERSATILIDAD E INNOVACION EN UNA SOLA PLATAFORMA  <span class="text-green">MIBODEGA</span></p>
		<v-layout wrap class="pl-141">
			<v-flex class="wrapper-text">
				<v-layout wrap>
					<v-flex  
						v-for="(item, index) in invoices" 
						:key="index"
						class="column">
						<p class="name-item p-7-mobile">{{ item.name }}</p>
						<p class="description-item p-7-mobile">{{ item.description }}</p>
						<div>
							<img 
								src="/static/img/laptop-reportes-l.png" 
								alt="image-invoice"
								v-if="index === 0"
								class="image-mobile"
							>
						</div>
					</v-flex>
					<v-flex xs12>
						<a href="#footer" class="btn-information mb-5">SOLICITA MÁS INFORMACIÓN</a>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex class="wrapper-image">
				<div class="wrapper-img">
					<img src="/static/img/cel-group.png" alt="" class="image-invoice">
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
export default {
	name: 'section-invoice',
	props: {
		invoices: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.section-invoice {
	background-color: map-get($colors, gold-text);
	padding-top: 33px;
	overflow: hidden;
	position: relative;
}

.title-invoice {
	color: map-get($colors, white);
	font-family: font(lato-regular);
	font-weight: 600;
	font-size: 32px;
	text-align: center;

	@media (max-width: 936px) {
		font-size: 20px;
		padding: 0 7%;
	}
}

.subtitle-invoice {
	color: map-get($colors, white);
	font-family: font(lato-regular);
	font-size: 24px;
	text-align: center;

	@media (max-width: 936px) {
		font-size: 20px;
		padding: 0 7%;
	}
}

.text-green {
	color: map-get($colors, title-green);
}

.content-invoice {
	display: grid;
	grid-column-gap: 39px;
	grid-template-columns: 281px 281px;
	grid-row-gap: 20px;
	margin-top: 20px;
}

.name-item {
	color: map-get($colors, white);
	font-family: font(lato-regular);
	font-weight: 600;
	font-size: map-get($sizes, medium22);
	margin-bottom: 0;

	@media (max-width: 936px) {
		text-align: center;
	}
}

.description-item {
	font-family: font(lato-regular);
	color: map-get($colors, title);
	font-size: 14px;
}

.flex {
	display: flex;
	margin-top: 20px;
	justify-content: space-around;
}

.btn-information {
	background-color: map-get($colors, white);
	border-radius: 19.5px;
	color: map-get($colors, gold-text);
	font-family: font(lato-regular);
	font-weight: 600;
	font-size: map-get($sizes, medium);
	padding: 9px 46px;
	text-decoration: none;
}

.content-img {
	margin-left: 45px;
}

.image-invoice {
	position: absolute;
	bottom: 0;
	width: auto;
	right: 0;
	max-width: 100%;
	max-height: 100%;
}

.pl-141 {
	padding-left: 7%;

	@media (max-width: 936px) {
		padding-left: 0;
	}
}

.column {
	flex-direction: column;
	width: 50%;

	@media (max-width: 936px) {
		width: 100%;
	}
}

.wrapper-img {
	position: relative;
  width: 100%;
}

.wrapper-text {
	width: 50%;

	@media (max-width: 936px) {
		width: 100%;
	}
}

.wrapper-image {
	width: 50%;

	@media (max-width: 936px) {
		display: none;
	}
}

.image-mobile {
	display: none;

	@media (max-width: 936px) {
		display: inline-block;
		height: 271px;
    margin-left: 50%;
    overflow: hidden;
	}
}

.p-7-mobile {
	@media (max-width: 936px) {
		padding: 0 7%;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home/section-invoice.vue